import styled from 'styled-components'

export const OrderedList = styled.ol`
  list-style-type: decimal;
  list-style-position: inside;
`

export const OrderedListItem = styled.li`
  margin-left: 4px;
`
